module.exports = __webpack_public_path__ + "static/media/daniela.44495f5a.png";